enum PropertyIcons {
    // ImageId does not exist.
    None = -1,

    // Categories icon
    Categories = 0,

    // High Importance icon
    ImportanceHigh = 1,

    // Attachment icon
    Attachment = 2,

    // ImageId for replied mail.
    MailListViewReplied = 3,

    // ImageId for forwarded mail.
    MailListViewForwarded = 4,

    // ImageId for IRM mail.
    MailListViewIRM = 5,

    // ImageId for replied IRM mail.
    MailListViewIRMReplied = 6,

    // ImageId for forwarded IRM mail.
    MailListViewIRMForwarded = 7,

    // ImageId for voice mail.
    MailListViewVoiceMailItem = 8,

    // ImageId for replied voice mail.
    MailListViewVoiceMailReplied = 9,

    // ImageId for forwarded voice mail.
    MailListViewVoiceMailForwarded = 10,

    // ImageId for IRM voice mail.
    MailListViewVoiceMailIRM = 11,

    // ImageId for fax.
    MailListViewFaxItem = 12,

    // ImageId for appointment.
    MailListViewAppointmentItem = 13,

    // ImageId for accepted appointment.
    MailListViewAppointmentAccepted = 14,

    // ImageId for declined appointment.
    MailListViewAppointmentDeclined = 15,

    // ImageId for tentative appointment.
    MailListViewAppointmentTentative = 16,

    // ImageId for canceled appointment.
    MailListViewAppointmentCanceled = 17,

    // ImageId for contact
    MailListViewContactItem = 18,

    // ImageId for task
    MailListViewTaskItem = 19,

    // ImageId for reoccurring task
    MailListViewTaskReocurItem = 20,

    // ImageId for journal.
    MailListViewJournalItem = 21,

    // ImageId for post.
    MailListViewPostItem = 22,

    // ImageId for note.
    MailListViewNoteItem = 23,

    // ImageId for delivery receipt.
    MailListViewDelivery = 24,

    // ImageId for non-delivery receipt.
    MailListViewNonDelivery = 25,

    // ImageId for approval request.
    MailListViewApprovalRequest = 26,

    // ImageId for approval response of Approve.
    MailListViewResponseApprove = 27,

    // ImageId for approval response of Reject.
    MailListViewResponseReject = 28,

    // ImageId for out of office message.
    MailListViewOutOfOffice = 29,

    // ImageId for read report.
    MailListViewReadReport = 30,

    // ImageId for reminder message.
    MailListViewReminderMessage = 31,

    // ImageId for Smime.
    Smime = 32,

    // ImageId for TrustedSender icon
    TrustedSender = 33,

    // ImageId for Charm icon
    Charm = 34,

    // ImageId for low importance icon
    ImportanceLow = 35,

    // ImageId for GlobalMentionedMe icon
    GlobalMentionedMe = 36,

    // ImageId for Snooze icon
    Snooze = 37,

    // ImageId for GlobalMentionedMe icon when read.
    ReadGlobalMentionedMe = 38,

    // ImageId for Link icon
    Link = 39,

    // ImageId for MailDismiss icon
    MailDismiss = 40,

    // ImageId for followed appointment.
    MailListViewAppointmentFollow = 41,

    // ImageId for Pinned Icon
    Pinned = 42,

    // ImageId for Flagged Icon
    Flagged = 43,

    // ImageId for Flag Completed Icon
    Completed = 44,

    // ImageID for Reminder Icon
    Reminder = 45,

    // ImageId for delegate calendar appointment.
    MailListViewAppointmentDelegate = 46,

    // ImageId for Smime Encrypted Mail.
    LockClosedRegular = 47,

    // ImageId for Smime Regular Mail.
    RibbonRegular = 48,
}

export default PropertyIcons;
